export const Skeleton = ({ className = '' }) => {
    return (
        <div className={`animate-pulse bg-mono-200 dark:bg-mono-800 rounded relative overflow-hidden ${className}`}>
            <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-mono-100 dark:via-mono-700 to-transparent" />
        </div>
    );
};

export const SkeletonList = ({ rows = 5 }) => {
    return (
        <div className="space-y-3">
            {Array.from({ length: rows }).map((_, i) => (
                <div key={i} className="flex items-center space-x-4">
                    <Skeleton className="h-12 w-12 rounded-full flex-shrink-0" />
                    <div className="flex-1 space-y-2">
                        <Skeleton className="h-4 w-3/4" />
                        <Skeleton className="h-3 w-1/2" />
                    </div>
                </div>
            ))}
        </div>
    );
};

export const SkeletonCard = () => {
    return (
        <div className="bg-white dark:bg-mono-950 border border-mono-200 dark:border-mono-800 rounded-xl shadow-mono p-6">
            <Skeleton className="h-6 w-1/3 mb-4" />
            <Skeleton className="h-4 w-full mb-2" />
            <Skeleton className="h-4 w-5/6 mb-2" />
            <Skeleton className="h-4 w-4/6" />
        </div>
    );
};

export const SkeletonTable = ({ columns = 4, rows = 10 }) => {
    return (
        <div className="bg-white dark:bg-mono-950 border border-mono-200 dark:border-mono-800 rounded-xl overflow-hidden">
            <div className="bg-mono-50 dark:bg-mono-950 border-b border-mono-200 dark:border-mono-800">
                <div className="grid gap-4 p-4" style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
                    {Array.from({ length: columns }).map((_, i) => (
                        <Skeleton key={i} className="h-4" />
                    ))}
                </div>
            </div>
            <div className="divide-y divide-mono-200 dark:divide-mono-800">
                {Array.from({ length: rows }).map((_, i) => (
                    <div key={i} className="grid gap-4 p-4" style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
                        {Array.from({ length: columns }).map((_, j) => (
                            <Skeleton key={j} className="h-4" />
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Skeleton;
